import { render, staticRenderFns } from "./EmergePage.vue?vue&type=template&id=4783013b"
import script from "./EmergePage.vue?vue&type=script&lang=js"
export * from "./EmergePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports